var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ">"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#6135FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M27.7071 19.7071C28.0976 19.3166 28.0976 18.6834 27.7071 18.2929L21.3431 11.9289C20.9526 11.5384 20.3195 11.5384 19.9289 11.9289C19.5384 12.3195 19.5384 12.9526 19.9289 13.3431L25.5858 19L19.9289 24.6569C19.5384 25.0474 19.5384 25.6805 19.9289 26.0711C20.3195 26.4616 20.9526 26.4616 21.3431 26.0711L27.7071 19.7071ZM27 18L11 18V20L27 20V18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.ed6e5513e1cb842e42dba3ae213edaea.svg";
export { ForwardRef as ReactComponent };